export enum ApplicationStep {
    AccountLookup = '1',
    AccountVerification = '2',
    CustomerInformation = '3',
    GeneratorFacilityInformation = '4',
    ApplicationFees = '5',
    ApplicationFeesReview = '6',
    ContactInformation = '7',
    ReviewAndSubmit = '8'
}